import { IEquipment } from '../types';
import { useTranslation } from 'react-i18next';
import EquipmentForm from '../components/tabs-component/EquipmentForm';
import { useCreateEquipment } from '../hooks';
import TenantPage from 'layouts/TenantPage';

const initEquipment: IEquipment = {
  id: null,
  code: '',
  description: '',
  workstation: null,
  status: null
};

export const CreateEquipment = () => {
  const { t } = useTranslation();
  const { onSubmit } = useCreateEquipment();

  const translationPrefix = 'pages.equipment.new';

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EquipmentForm equipment={initEquipment} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateEquipment;
